import request from './axios'





//技术标准查询 11
export const getStandard = (data) => {
  return request({
    url: '/ca-share-column/policy-standard/standard/endpoint/query-standard',
    method: 'get',
    data,
    params: data
  })
}

//新闻  11
export const getNews = (data) => {
  return request({
    url: '/ca-share-column/policy-standard/news/endpoint/query-news',
    method: 'get',
    data,
    params: data
  })
}


//印章机构列表 11
export const getSealOrgList = (data) => {
  return request({
    url: '/ca-share-seal-org/seal-org/endpoint/get-seal-org-catalog',
    method: 'post',
    data
  })
}

//获取验证码 11
export const getcode = (params1, params2) => {
  return request({
    url: '/ca-share-column/user-registration/registration/get-sms-verify-code/' + params1 + '/' + params2,
    method: 'get',
  })
}

//登记下载用户信息 11
export const addUser = (data) => {
  return request({
    url: '/ca-share-column/user-registration/registration/register-download-user-info',
    method: 'post',
    data
  })
}
//登记交易平台信息1111
export const addUser2 = (data) => {
  return request({
    url: '/ca-share-column/column-catalog/platform/registration/register-platform-info',
    method: 'post',
    data
  })
}




//筛选查询已发布平台 111
export const getPublishPlatform = (data) => {
  return request({
    url: '/ca-share-column/column-catalog/platform/endpoint/get-platform-catalog',
    method: 'get',
    data,
    params: data
  })
}
//按省分类获取交易平台目录
export const getProvincePlatformCatalog = (data) => {
  return request({
    url: '/ca-share-column/column-catalog/platform/endpoint/get-province-platform-catalog',
    method: 'get',
    data,
    params: data
  })
}




//获取CA共享组件已开通app、app对应CA机构、CA组件开通印章机构列表
export const applyView = (data) => {
  return request({
    url: '/ca-share-column/column-catalog/platform/endpoint/apply-view/v2',
    method: 'post',
    data
  })
}
//查看交易平台信息
export const platformView = (data) => {
  return request({
    url: '/ca-share-column/column-catalog/platform/endpoint/view/' + data,
    method: 'post',
    data
  })
}

//专栏门户查看交易平台信息
export const platformView2 = (data) => {
  return request({
    url: '/ca-share-column/column-catalog/platform/endpoint/view/detail/' + data,
    method: 'post',
    data
  })
}




//查询已发布的CA机构列表 11
export const getOrgCatalog = (data) => {
  return request({
    url: '/ca-share-column/ca-org-catalog/endpoint/get-ca-org-catalog',
    method: 'post',
    data
  })
}

//筛选CA互认APP目录 11
export const getappList = (data) => {
  return request({
    url: '/ca-share-column/mutual-recognition-app/directory/endpoint/get-app-catalog',
    method: 'post',
    data
  })
}




//查询已发布的CA机构列表
// export const getTestScripts = (data) => {
//   return request({
//     url: '/ca-org-test-scripts/endpoint/get-published-last-version-test-scripts',
//     method: 'get',
//     data,
//     params: data
//   })
// }

//接入文档预览11
export const documentPreview = (data) => {
  return request({
    url: '/ca-share-document/document/endpoint/preview-documents',
    method: 'get',
    data,
    params: data
  })
}



//查看源码信息
export const sourceCodeinfo = (data) => {
  return request({
    url: '/zz-ca-share-column/zz-module-mutual-recognition-share/source-code/endpoint/query-source-code',
    method: 'get',
    data,
    params: data
  })
}





//自主测试环境信息查询 11
export const autonomyTest = (data) => {
  return request({
    url: '/zz-ca-share-column/zz-module-mutual-recognition-share/autonomy-test/view-self-help-test-environment-url-by-type/01',
    method: 'get',
    // data,
    params: data
  })
}





//接入文档下载11
export const endpointDownload = (data) => {
  return request({
    url: '/ca-share-document/document/endpoint/download-documents',
    method: 'get',
    data,
    responseType: 'blob',
    params: data
  })
}


//下载获取最新的测试脚本
// export const DownloadTestScripts = (data) => {
//   return request({
//     url: '/ca-share-column/test-scripts/endpoint/get-published-last-version-test-scripts',
//     method: 'get',
//     data,
//     responseType: 'blob',
//     params: data
//   })
// }   
//下载获取最新的测试脚本 11
export const DownloadTestScripts = (data) => {
  return request({
    url: '/ca-share-column/test-scripts/endpoint/get-test-scripts-download-url',
    method: 'get',
    data,
    params: data
  })
}


//查询常见问题类型
export const getqstype = (data) => {
  return request({
    url: '/zz-infra/zz-system/dict-biz/dictionary-dict-biz?code=common-problem_type',
    method: 'get',
    data,
    params: data
  })
}





//统计数量
export const getEndpointCount = (data) => {
  return request({
    url: '/ca-share-column/column-catalog/platform/endpoint/count',
    method: 'get',
    data,
    params: data
  })
}



//获取已发布最新版本APP-SDK 11
export const getSDK = (data) => {
  return request({
    url: '/ca-share-column/mutual-recognition-app/sdk/endpoint/get-published-last-version-sdk',
    method: 'get',
    data,
    params: data
  })
}


//互认共享组件简介-说明查看
export const getintroduction = (data) => {
  return request({
    url: '/zz-ca-share-column/zz-module-mutual-recognition-share/share-assembly-introduction/view/' + data.type,
    method: 'get',
    data,
    params: data
  })
}


//获取文件流
export const downloadWithFilePath = (data) => {
  return request({
    url: '/zz-infra/zz-resource/oss/endpoint/download-with-file-path',
    method: 'get',
    data,
    responseType: 'blob',
    params: data
  })
}


//下载源码 11
export const sourceCodeDownload = (data) => {
  return request({
    url: '/zz-ca-share-column/zz-module-mutual-recognition-share/source-code/endpoint/download-source-code-files',
    method: 'get',
    data,
    responseType: 'blob',
    params: data
  })
}


//下载安装包 11
export const packageDownload = (data) => {
  return request({
    url: '/zz-ca-share-column/zz-module-mutual-recognition-share/installation-package/endpoint/download-installation-package',
    method: 'get',
    data,
    responseType: 'blob',
    params: data
  })
}





// export const downloadWithFilePath = (data) => {
//   return request({
//     url: '/zz-infra/zz-resource/oss/endpoint/download-with-file-path',
//     method: 'get',
//     data,
//     params: data
//   })
// }




//根据问题类型查询常见问题 by
export const getproblemList = (data) => {
  return request({
    url: '/remotebidevaluationcolumn/remotebidevaluationbackstage/question/paging-get-published-question-list',
    method: 'post',
    data
  })
}